export default __webpack_public_path__ + "static/media/Skin Remembers official.688c495e.mp4";